export default {
  "characteristics": {
    "title": "Coffee \nCharacteristics",
    "flavor": "Flavor",
    "flavor_description": "Yellow fruits, caramel, chocolate",
    "aroma": "Aroma",
    "aroma_description": "Yellow fruits, chocolate",
    "body": "Body",
    "body_description": "Full-bodied with a silky to creamy texture",
    "acidity": "Acidity",
    "acidity_description": "Citrus, bright and intense",
    "finish": "Finish",
    "finish_description": "Medium-lasting and sweet"
  }
}
